module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0003.jpg?v=93063fda";